































































import Vue from 'vue'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import Header from '~/components/Header.vue'
import Footer from '~/components/Footer.vue'
import getAllEventCategories from '~/apollo/queries/getAllEventCategories.gql'

Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_ATTR: ['target']
  }
})

export default Vue.extend({
  components: {
    Header,
    Footer
  },
  async fetch () {
    const { data } = await this.$apolloProvider.defaultClient.query({
      query: getAllEventCategories
    })
    this.eventCategories = data.eventCategories
  },
  data () {
    return {
      eventCategories: null
    }
  },
  computed: {
    CurrentSlug (): string {
      return this.$route.params.category
    }
  }
})
